import {
  $qProvider
} from '../../../providers';
import endsWith from 'lodash/endsWith';
import startsWith from 'lodash/startsWith';

// @ngInject
class UrlResolverService {
  // @ngInject
  constructor($urlMatcherFactory) {
    this.$urlMatcherFactory = $urlMatcherFactory;
  }
  resolveUrl(path, config) {
    let {
      pathParams,
      server
    } = config;
    let compiledPath;
    if (!pathParams) {
      compiledPath = path;
    } else {
      compiledPath = this.$urlMatcherFactory.compile(path).format(pathParams);
    }
    // Ne doit être utilisé que pour nos requêtes
    const serveur = server || '/';
    let finalUrl = serveur;
    if (!endsWith(serveur, '/')) {
      finalUrl += '/';
    }
    if (startsWith(compiledPath, '/')) {
      finalUrl += compiledPath.substr(1);
    } else {
      finalUrl += compiledPath;
    }
    return $qProvider().when(finalUrl);
  }
}

export default UrlResolverService;



// WEBPACK FOOTER //
// ./src/modules/common/services/url-resolver.service.js